import { DocumentMetadataPropertyTypeEnum } from 'shared/domains/apollo/generated/types';
const METADATA_PREFIX = 'metadataDocument';
const getMetadataPropertyName = (property) => `${METADATA_PREFIX}${property.name}`;
const areValuesIdentical = (values) => values.every((value) => value === values[0]);
const areArraysIdentical = (values) => {
    const arrayValues = values.map((value) => (Array.isArray(value) ? value : [value]));
    const arrayStrings = arrayValues.map((value) => value.join(''));
    return areValuesIdentical(arrayStrings);
};
export const getMetadataPropertyInitialValue = (selected, property) => {
    if (property.type === DocumentMetadataPropertyTypeEnum.Number ||
        property.type === DocumentMetadataPropertyTypeEnum.Boolean ||
        property.type === DocumentMetadataPropertyTypeEnum.Date ||
        property.type === DocumentMetadataPropertyTypeEnum.List) {
        const values = selected.map((item) => item[getMetadataPropertyName(property)]);
        const identical = areValuesIdentical(values);
        const valueSet = values[0] !== undefined && values[0] !== null;
        return identical && valueSet ? values[0] : undefined;
    }
    if (property.type === DocumentMetadataPropertyTypeEnum.Reference) {
        const values = selected.map((item) => item[getMetadataPropertyName(property)]);
        const identical = areArraysIdentical(values);
        const valueSet = values[0] !== undefined && values[0] !== null;
        return identical && valueSet ? values[0] : undefined;
    }
    return undefined;
};
